function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v20H0V5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,5v20H0L30,5Z",
    style: {
      fill: "#003087"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,13.333V5h12.5L0,13.333Z",
    style: {
      fill: "gold"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.333,8.611l2.887,5-2.887,5-2.887-5,2.887-5ZM13.333,13.611l-5,2.887-5-2.887,5-2.887,5,2.887Z",
    style: {
      fill: "#101820"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.333,
    cy: 13.611,
    r: 4.33,
    style: {
      fill: "#101820"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.333,
    cy: 13.611,
    r: 3.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9.776 13.611 10.498 12.361 9.055 12.361 8.333 11.111 7.611 12.361 6.168 12.361 6.89 13.611 6.168 14.861 7.611 14.861 8.333 16.111 9.055 14.861 10.498 14.861 9.776 13.611",
    style: {
      fill: "#d50032"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBq);
export default __webpack_public_path__ + "static/media/BQ.41408749b206dbc83f41cefe0b43a25d.svg";
export { ForwardRef as ReactComponent };